<script lang="ts">
    import { createEventDispatcher } from 'svelte'
import ImportCalendar from './ImportCalendar.svelte';
import ImportPharmacy from './ImportPharmacy.svelte';
import ManageCalendar from './ManageCalendar.svelte';
import ManagePharmacy from './ManagePharmacy.svelte';

    const dispatcher = createEventDispatcher()
    let managePharmacy: boolean = false;
    let manageCalendar: boolean = false;
    let importPharmacy: boolean = false;
    let importCalendar: boolean = false;
    export let username: string;

    const verifySession = (data) => {
        dispatcher("verifySession")
    }

    const toggleManagePharmacy = () => {
        manageCalendar = false
        importPharmacy = false
        importCalendar = false
        managePharmacy = true
    }

    const toggleManageCalendar = () => {
        managePharmacy = false
        importPharmacy = false
        importCalendar = false
        manageCalendar = true
    }

    const toggleImportPharmacy = () => {
        managePharmacy = false
        importCalendar = false
        manageCalendar = false
        importPharmacy = true
    }

    const toggleImportCalendar = () => {
        managePharmacy = false
        importPharmacy = false
        manageCalendar = false
        importCalendar = true
    }

    const logout = () => {
        dispatcher("logout")
    }

</script>
<div class="grid justify-items-stretch mx-2">
    <div class="border-2 rounded-xl logout shadow-xl p-2 justify-self-end transition duration-500 ease-in-out transform -translate-y-2 hover:translate-y-1 cursor-pointer select-none" on:click="{logout}">Logout</div>
</div>
<div class="flex space-x-12">
    <div class="grid grid-cols-1 border-2  manage-box shadow-xl p-2 w-auto divide-y-2 h-48">
        <div class="cursor-pointer hover:text-gray-700 p-1" on:click="{toggleManagePharmacy}">Manage Apotheken</div>
        <div class="cursor-pointer hover:text-gray-700 p-1 " on:click="{toggleManageCalendar}">Manage Kalender</div>
        <div class="cursor-pointer hover:text-gray-700 p-1 " on:click="{toggleImportPharmacy}">Import Apotheken</div>
        <div class="cursor-pointer hover:text-gray-700 p-1 " on:click="{toggleImportCalendar}">Import Kalender</div>
    </div>
    
    <div class="grid justify-items-stretch">
        {#if managePharmacy}
            <ManagePharmacy username={username} on:verifySession={verifySession}/>
        {/if}
        {#if manageCalendar}
            <ManageCalendar username={username} on:verifySession={verifySession}/>
        {/if}
        {#if importPharmacy}
            <ImportPharmacy username={username} on:verifySession={verifySession}/>
        {/if}
        {#if importCalendar}
            <ImportCalendar username={username} on:verifySession={verifySession}/>
        {/if}
    </div>
</div>
<style>
    .logout{
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
    .manage-box{
        border-left:none;
    }
</style>